
export default class NeonConfiguration {
  public id: string
  public available: boolean
}
